import clsx from 'clsx'
import styles from './index.module.scss'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ButtonCommon } from '../../../components/Button'
import { InputCommon } from '../../../components/Input'
import { LockIcon } from '../../../assets/icons'
import { Form } from 'antd'
import { CommonUi } from '../../../until/text/ui'
import { openNotificationWithIcon, useForgotPassword } from '../../../hooks'
import { regex } from '../../../until'
import { useTranslation } from 'react-i18next'

export const ForgotPasswordForm = () => {
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()
  const mutationForgotPassword = useForgotPassword()
  const { t, i18n } = useTranslation()

  useEffect(() => {
    const isValid = form.getFieldsError().some((error) => error?.errors?.length > 0)
    if (isValid) {
      form.validateFields(['email'])
    }
  }, [i18n.language])
  
  const onFinish = async (value: any) => {
    setLoading(true)
    try {
      // const res = await mutationForgotPassword.mutateAsync({ email: email })
      const res = await mutationForgotPassword.mutateAsync(value)
      openNotificationWithIcon('success', '', res.data)
    } catch (error: any) {
      openNotificationWithIcon('error', '', error?.message)

      setLoading(false)
    }
    setLoading(false)
  }
  return (
    <div className={styles.forgot}>
      <div className={clsx(styles.forgot__title)}>
        <h1 style={{ textAlign: 'center', color: 'white' }}>{CommonUi.logo}</h1>
      </div>
      <div className={clsx(styles.forgot__page)}>
        <div className={clsx(styles.password__page)}>
          <div style={{ textAlign: 'center', marginBottom: '16px' }}>
            <LockIcon />
          </div>
          <h1>{t('forgotPassword.title')}</h1>
          <Form form={form} className={clsx(styles.password__form)} onFinish={onFinish} layout="vertical">
            <Form.Item
              className={clsx(styles.password__form__item)}
              label={t('forgotPassword.email')}
              name="email"
              rules={[
                {
                  required: true,
                  message: `${t('login.authMessage.requiredEmail')}`,
                },
                {
                  pattern: regex.validateEmail,
                  message: `${t('login.authMessage.validateEmail')}`,
                },
              ]}
              validateTrigger="onSubmit"
            >
              <InputCommon placeholder={t('forgotPassword.placeHolder')} />
            </Form.Item>
            <div className={clsx(styles.form__btnGroup)}>
              <ButtonCommon
                className={clsx(styles.btn__reset)}
                loading={loading}
                htmlType="submit"
                lang={i18n.language}
              >
                {t('forgotPassword.resetPassword')}
              </ButtonCommon>
              <ButtonCommon type="ghost" className={clsx(styles.btn__back__login)} >
                <Link to={'/login'}>{t('forgotPassword.backToLogin')}</Link>
              </ButtonCommon>
            </div>
          </Form>
        </div>
      </div>
    </div>
  )
}
